export type Unit = "px" | "%" | "em" | "rem" | "vw" | "vh" | "auto";

export const UNITS: Unit[] = ["px", "%", "em", "rem", "vw", "vh", "auto"];

export const UNIT_CONSTRAINTS: Partial<
  Record<Unit, { min?: string; max?: string }>
> = {
  px: { min: "0" },
  "%": { min: "0", max: "100" },
  em: { min: "0" },
  rem: { min: "0" },
  vw: { min: "0", max: "100" },
  vh: { min: "0", max: "100" },
  auto: {},
};
